import Api from "./api";
const base64 = require("base-64");

class AuthApi extends Api {

	constructor(token, clientID, onUnauthorized) {
		super(token, clientID, onUnauthorized);

		this.baseUrl = this.getBaseUrl() + "accounts/";
	}


	logout(onSuccess, onError) {
        fetch(
            this.baseUrl + "apikeys/revoke",
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.getToken()
                }
            }
        ).then(
            (response) => {
                if (!response.ok)
                    throw response;
                onSuccess();
            }
        ).catch(
            () => onError()
        )
    }

	getLogInURL() {
		return this.baseUrl + 'refresh'
	}

	getLogOutURL() {
		return this.baseUrl + 'logout/'
	}
}

export default AuthApi;
